import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { BehaviorSubject, map, mergeMap } from 'rxjs';
import { CoreItemType } from '../core-item/core-item';
import { CoreItemService } from '../core-item/core-item.service';
import { CreditHistory, CreditHistoryBackend } from './credit';

@Injectable({
  providedIn: 'root',
})
export class CreditHistoryService {
  private _changeSubject = new BehaviorSubject<CreditHistoryBackend | undefined>(undefined);

  constructor(private coreItemService: CoreItemService) {}

  creditHistoryList$() {
    return this._changeSubject.asObservable().pipe(
      mergeMap((_) => {
        return this.coreItemService.getCoreItemList$([CoreItemType.creditHistory]).pipe(
          map((list) => (list ?? []).filter((item) => item.coreType === CoreItemType.creditHistory) as CreditHistory[]),
          map((list) =>
            list.sort((a, b) => ((a.createdTime ?? DateTime.local()) < (b.createdTime ?? DateTime.local()) ? 1 : -1))
          )
        );
      })
    );
  }

  getTitle(creditHistory: CreditHistory) {
    if (creditHistory.subData.interview) {
      console.log('----- creditHistory.subData:', creditHistory.subData);
      return `${creditHistory.subData.interview.goalPosition} @${creditHistory.subData.interview.goalCompany} ${creditHistory.subData.interview.interviewRound}`;
    } else if (creditHistory.subData.payment) {
      return 'Purchased Points';
    } else if (creditHistory.subData.referId) {
      return 'Referral Bonus';
    } else {
      return '';
    }
  }
}
